import React from 'react';
import styled from 'styled-components';
import Content from '../../../content';
import Item from './item';

// Tag could be 'ol' as well
const Ul = ({ className, Tag = 'ul', items }) => (
  <Content>
    <Tag className={className}>
      {items.map((item) => <Item key={item.id} {...item} />)}
    </Tag>
  </Content>
);

export default styled(Ul)`
  width: 100%;
`;
